import { FC } from "react";

import Desktop from "../../../../assets/images/content/pillar-2/units-traded-in-europe/units-traded-in-Europe-intro-desktop.svg";
import Mobile from "../../../../assets/images/content/pillar-2/units-traded-in-europe/units-traded-in-Europe-intro-mobile.svg";

const UnitsTradedInEuropeIntro: FC = () => {
	return (
		<div className="flex flex-col items-center justify-center">
			<img className="hidden md:block w-9/12" src={Desktop} role="presentation" />
			<img className="block md:hidden" src={Mobile} role="presentation" />
		</div>
	);
};

export { UnitsTradedInEuropeIntro };
